<template>
  <a-card class="m-t-10" :bordered='false'>
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">经销商审核详情</span>
  </a-card>
  <a-card :bordered='false'>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 2 }" :wrapper-col="{ span: 10 }">
      <a-form-item label="经销商编号" name="dealer_sn">
        {{form.dealer_sn}}
      </a-form-item>
      <a-form-item ref="dealer_name" label="经销商名称" name="dealer_name">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.dealer_name" :disabled="form.is_examine!=0" placeholder='请输入经销商名称' />
          </a-col>
          <a-col :span="12">
            <p>最多50个字</p>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="leader_name" label="负责人" name="leader_name">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.leader_name" :disabled="form.is_examine!=0" :readonly='$route.query.type == "look"' placeholder='请输入经销商负责人姓名' />
          </a-col>
          <a-col :span="12">
            <p>最多8个字</p>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="leader_phone" label="手机号码" name="leader_phone">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.leader_phone" disabled :maxlength='11' placeholder='请输入经销商联系人手机号码' />
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="business_license_image" label="营业执照">
        <div class="s_po_re">
          <div v-if="form.is_examine==0">
            <material :groupType='1' :image="form.business_license_image" :max="1" v-on:handlechoose="(data)=>{form.business_license_image=data}" v-on:handledel="(data)=>{form.business_license_image=''}" />
          </div>
          <div class='ant-upload-list ant-upload-list-picture-card' v-else>
            <div class='ant-upload-list-picture-card-container' v-if='form.business_license_image'>
              <span>
                <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                  <div class="ant-upload-list-item-info">
                    <img :src="info.picdomain+'/'+form.business_license_image" class='ant-upload-list-item-image' />
                  </div>
                </div>
              </span>
            </div>
            <p v-else class="height-39 s_flex_ali">无</p>
          </div>
        </div>
      </a-form-item>
      <a-form-item ref="region" label="经销商地址" name="region">
        <!-- <a-form-item ref="address_list" label="经销商地址" name="address_list"> -->
        <a-row :gutter="16">
          <a-col :span="12">
            <a-cascader v-model:value="form.address_list" :disabled='$route.query.type == "look"' :field-names="{ label: 'name', value: 'id', children: 'children' }" :options="addressList" placeholder="请选择经销商地址" @change="onChangeAddress" />
          </a-col>
        </a-row>
        <!-- </a-form-item> -->
      </a-form-item>
      <a-form-item ref="address" label="详细地址" name="address">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.address" :disabled="form.is_examine!=0" :readonly='$route.query.type == "look"' placeholder='请输入详细地址' @change="changeVal" />
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="lng" label="经纬度"  >
        <a-row :gutter="16">
          <a-col :span="6">
            <a-input v-model:value="form.lat" placeholder='请输入经度' />
          </a-col>
          <a-col :span="6">
            <a-input v-model:value="form.lng" placeholder='请输入纬度' />
          </a-col>
          <a-col :span="12">
            <a-button type="primary" @click='showMap = true' v-if="form.is_examine==0">
              地图选择
            </a-button>
          </a-col>
        </a-row>
      </a-form-item>
       <a-form-item label="推荐经销商" >
         <p>{{form.extension_dealer_name || '无'}}</p>
      </a-form-item>
      <a-form-item label="申请级别" >
        {{form.level_name}}
      </a-form-item>
      <a-form-item label="所属上级">
        {{form.parent_dealer_name}}
      </a-form-item>
              <a-form-item ref="sale_cat_id" label="销售大区" name="sale_cat_id"  :rules="[{ required: true, message: '请选择销售大区' }]" >
             <a-select v-model:value="form.sale_cat_id" placeholder="请选择" style="width:50%">
                  <a-select-option :value="v.id" v-for="v in SaleCatList" :key="v.id">{{v.sale_cat_name}}</a-select-option>
             </a-select>
        </a-form-item> 
    <!-- <div class=" s_over_h mb25">
      <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali s_bf58 s_c333">经销商资料</p>
      <div class="s_p24">
        <p class="s_c333   s_lin_h35">经销商编号：</p>
        <p class="s_c333   s_lin_h35">经销商名称：{{form.dealer_name}}</p>
        <p class="s_c333   s_lin_h35">上级经销商：{{form.parent_dealer_name}}</p>
        <p class="s_c333   s_lin_h35">负责人：{{form.leader_name}}</p>
        <p class="s_c333   s_lin_h35">手机号码：{{form.leader_phone}}</p>
        <p class="s_c333   s_lin_h35">经销商地址：</p>
        <p class="s_c333   s_lin_h35">代理级别：{{form.level_name}}</p>
        <p class="s_c333   s_lin_h35">销售区域：<span v-for='item in form.sale_area_text' :key='item'>
            <span>{{item.country_name}}</span>
            <span>{{item.province_name}}</span>
            <span>{{item.city_name ?'-'+item.city_name:''}}</span>
            <span>{{item.area_name ?'-'+item.area_name:''}}</span>
            <span class="don">、</span>
          </span></p>
        <div class="s_c333   s_lin_h35">营业执照：
          <div class='ant-upload-list ant-upload-list-picture-card' v-if='form.business_license_image'>
            <div class='ant-upload-list-picture-card-container'>
              <span>
                <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                  <div class="ant-upload-list-item-info">
                    <img :src="info.picdomain+'/'+form.business_license_image" class='ant-upload-list-item-image' />
                  </div>
                </div>
              </span>
            </div>
          </div>
          <span v-else>无</span>
        </div>
      </div>
    </div> -->
    <div class=" s_over_h">
      <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">经销商审核</p>
      <div class="s_p24">
        <!-- <p class="s_c333   s_lin_h35 ">申请级别： {{form.level_name}}</p>
        <p class="s_c333   s_lin_h35 ">所属上级： {{form.parent_dealer_name}}</p> -->
        <p class="s_c333   s_lin_h35 " v-if="form.is_examine!=0">审核状态： {{form.is_examine==1?'审核通过':'审核不通过'}}</p>
        <p class="s_c333   s_lin_h35 " v-if="form.is_examine== 2">拒绝原因： {{form.examine_remark}}</p>
        <!--  -->
        <a-radio-group class="mb10" v-model:value="reviewValue" @change="onChange" v-if="form.is_examine==0">
          <a-radio :value="1">
            <span class="s_c333   s_lin_h35">审核通过</span>
          </a-radio>
          <a-radio :value="2">
            <span class="s_c333   s_lin_h35">审核不通过</span>
          </a-radio>
        </a-radio-group>
        <div class="s_flex_ali" v-if='reviewValue == 2'>
          <p class="s_c333   s_lin_h35 width-100 xing">拒绝原因：</p>
          <a-textarea v-model:value="remarks" style='width:300px' placeholder="请输入备注" :rows="4" />
        </div>
        <a-form-item ref=""  label="销售区域" name="销售区域" help='最多20个区域，区域不能重叠或重复，销售区域不能超出上级销售区域' v-if='reviewValue == 1'>
          <a-row class="m-b-15" type="flex" justify="space-between" align="middle">
            <a-col :span="4">
              <div class="">
                <a-select v-model:value="country" placeholder="请选择" style="width:200px">
                  <a-select-option :value="100000">全国</a-select-option>
                </a-select>
                <a-select v-model:value="province" allowClear placeholder="请选择省" @change="selectProvince" style="width:200px">
                  <a-select-option v-for='(item,index) in provinceList' :key="index" :value="item.id">{{item.name}}
                  </a-select-option>
                </a-select>
                <a-select v-model:value="city" allowClear placeholder="请选择市" @change="selectCity" style="width:200px">
                  <a-select-option v-for='(item,index) in cityList' :key="index" :value="item.id">{{item.name}}
                  </a-select-option>
                </a-select>
                <a-select v-model:value="area" allowClear placeholder="请选择区" @change="selectArea" style="width:200px">
                  <a-select-option v-for='(item,index) in areaList' :key="index" :value="item.id">{{item.name}}
                  </a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :span="2">
              <a-button type="primary" @click="addCity" :disabled='$route.query.type == "look"'>添加</a-button>
            </a-col>
            <a-col :span="8">
              <div class="s_bor10 p-5 height-160" style="overflow-x: auto;overflow-y:scroll;border:1px solid #ccc">
                <div class="s_flex_bian_c s_bf58 bor-rad-5 p-tb0-lr10 m-b-10" v-for='(item,index) in rigthArr' :key='index'>
                  <p>{{item.country_name}}{{item.province_name}}{{item.city_name}}{{item.area_name}}</p>
                  <CloseCircleFilled class="s_c999" v-if='$route.query.type == "look"' />
                  <CloseCircleFilled class="s_c999" @click='delRegion(index)' v-else />
                </div>
              </div>
            </a-col>
          </a-row>
        </a-form-item>
        <!--  -->
        <div class="mt35" v-if="form.is_examine==0">
          <a-button style='width:100px' type="primary" v-has:dealerReviewSubmit="onSubmit" :loading="confirmLoading">提交</a-button>
        </div>
      </div>
    </div>
    <div class="height-30"></div>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" title="选择经纬度" centered v-model:visible="showMap" :width='1300' :footer="null" destroyOnClose>
    <gdmap v-on:confirm="confirm" :provinceData='mapProvince' :address='form.address' :lng='form.lng' :lat='form.lat'></gdmap>
  </a-modal>
</template>

<script>
import { LeftOutlined, CloseCircleFilled } from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import { getExamineDetail, setDealerReview,getSaleCat } from "@/api/dealer";
import { getArea } from "@/api/public";
import store from "@/store";
// 初始化默认筛选项数值
let defForm = {
  dealer_sn: "",
  dealer_name: "",
  province: "",
  city: "",
  region: "",
  address: "",
  password: "",
  leader_name: "",
  leader_phone: "",
  payee_account: "",
  sale_area: [],
  sale_area_text: [],
  sale_cat_id:""
};
export default {
  components: { LeftOutlined, CloseCircleFilled },
  setup() {
    const form = ref({ ...defForm });
    const state = reactive({
      rules: {
        dealer_sn: [
          { required: true, message: "请输入经销商编号" },
          { max: 20, message: "最多20个字符", trigger: "blur" },
        ],
        dealer_name: [{ required: true, message: "请输入经销商名称" }],
        leader_name: [{ required: true, message: "请输入负责人姓名" }],
        leader_phone: [{ required: true, message: "请输入手机号码" }],
        region: [{ required: true, message: "请选择地区" }],
        address: [{ required: true, message: "请输入详细地址" }],
        level_id: [{ required: true, message: "请选择经销商等级" }],
        up_name: [{ required: true, message: "请选择上级经销商" }],
      },
      info: store.state.user.info,
      showMap: false,
      reviewValue: null,
      no: "",
      confirmLoading: false,
      remarks: "",
      cityObj: {
        country_name: "",
        province_name: "",
        city_name: "",
        area_name: "",
        id: [],
      },
      mapProvince: {
        province_name: "",
        city_name: "",
        area_name: "",
      },
      country: 100000,
      province: undefined,
      city: undefined,
      area: undefined,
      cityIndex: undefined,
      addressList: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      rigthArr: [],
    });
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    const getMore = async (id) => {
      const hide = message.loading("正在加载中...", 0);

      let res = await getExamineDetail(id).then((res) => res.data).catch(error=>error);
      setTimeout(hide);
      if (iscode(res)) {
        form.value = res.data;
      form.value.address_list = [
          res.data.province,
          res.data.city,
          res.data.region,
        ];
        let result = await getArea().then((res) => res);
        setTimeout(hide);
        if (form.value.province != 0) {
          var provinceIndex = _lodash.findIndex(result.data, [
            "id",
            res.data.province,
          ]);
          if (!provinceIndex)
            form.value.province = result.data[provinceIndex].name;
          if (!form.value.business_license_image) {
            form.value.business_license_image = "";
          }
          var cityIndex = _lodash.findIndex(
            result.data[provinceIndex].children,
            ["id", res.data.city]
          );
          form.value.city = result.data[provinceIndex].children[cityIndex].name;

          var regionIndex = _lodash.findIndex(
            result.data[provinceIndex].children[cityIndex].children,
            ["id", res.data.region]
          );
          form.value.region =
            result.data[provinceIndex].children[cityIndex].children[
              regionIndex
            ].name;
        }

        setTimeout(hide);
      } else {
        message.error(res.msg);
      }
      setTimeout(() => {
        state.confirmLoading = false;
      }, 1000);
    };
    const ruleForm = ref("");
    const onSubmit = async () => {
      ruleForm.value
        .validate()
        .then(async () => {
          if (state.remarks == "" && state.reviewValue == 2) {
            message.error("请输入拒绝原因！");
            return false;
          }
          if (state.rigthArr.length == 0 && state.reviewValue == 1) {
            message.error("请选择销售区域");
            return false;
          } else {
            form.value.sale_area = [];
            for (var i in state.rigthArr) {
              state.rigthArr[i].id = _lodash.uniq(state.rigthArr[i].id);
              form.value.sale_area.push(
                _lodash.join(_lodash.uniq(state.rigthArr[i].id), ",")
              );
            }
            form.value.sale_area_text = state.rigthArr;
          }
          if (state.confirmLoading) return;
          state.confirmLoading = true;
          const hide = message.loading("正在加载中...", 0);
          let res = await setDealerReview($route.query.id, {
            ...form.value,
            business_license_image: form.value.business_license_image,
            is_examine: state.reviewValue,
            examine_remark: state.remarks,
            sale_area_text: form.value.sale_area_text,
            sale_area: form.value.sale_area,
          }).then((res) => res.data);
          setTimeout(hide);
          if (iscode(res)) {
            message.success(res.msg);
            setTimeout(() => {
              $router.go(-1);
            }, 1000);
          } else {
            state.confirmLoading = false;
            message.error(res.msg);
          }
        })
        .catch((error) => {
          message.error("请完善信息");
        });
    };
    onMounted(() => {
      getMore($route.query.id);
    });
    //获取省市区
    const getAreaList = async (arr) => {
      let result = await getArea().then((res) => res);
      state.provinceList = result.data;
      state.addressList = result.data;
    };
    // 获取销售大区
    const SaleCatList=ref()
    const getSaleCatList=async()=>{
     let result=await getSaleCat().then(res=>res.data).catch(error=>error)
     console.log(result)
     SaleCatList.value=result.data
    }
    onMounted(() => {
      getAreaList();
      getSaleCatList()
    });

    // 销售区域选择省
    const selectProvince = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityList = state.provinceList[option.key].children;
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          province_name: state.provinceList[option.key].name,
          city_name: "",
          area_name: "",
          id: [e],
        };
      } else {
        state.cityList = [];
        state.areaList = [];
        state.province = undefined;
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          province_name: "",
          city_name: "",
          area_name: "",
          id: [],
        };
      }
    };
    // 销售区域选择市
    const selectCity = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityObj.id.splice(1, 2);
        state.areaList = state.cityList[option.key].children;
        state.area = undefined;
        state.cityObj.id.push(e);
        state.cityObj = {
          ...state.cityObj,
          city_name: state.cityList[option.key].name,
          area_name: "",
        };
      } else {
        state.cityObj.id.splice(1, 2);
        state.areaList = [];
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          ...state.cityObj,
          city_name: "",
          area_name: "",
        };
      }
    };
    // 销售区域选择区
    const selectArea = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityObj.id.splice(2, 1);
        state.cityObj.id.push(e);
        state.cityObj = {
          ...state.cityObj,
          area_name: state.areaList[option.key].name,
        };
      } else {
        state.area = undefined;
        state.cityObj.id.splice(2, 1);
        state.cityObj = {
          ...state.cityObj,
          area_name: "",
        };
      }
    };
    // 清空
    const clearCityArr = () => {
      state.province = undefined;
      state.city = undefined;
      state.area = undefined;
      state.cityList = [];
      state.areaList = [];
      state.cityObj = {
        country_name: "",
        province_name: "",
        city_name: "",
        area_name: "",
        id: [],
      };
    };
    // 添加销售区域
    const addCity = () => {
      var left = state.cityObj; //左边数组
      var right = state.rigthArr; //右边数组
      // var superiorArea = state.superiorArea; // 上级经销商销售区域
      if (_lodash.indexOf(left.id, 100000) !== -1) {
        left.id = _lodash.filter(left.id, function (o) {
          return o != 100000;
        });
      }
      if (left.id.length == 0) {
        left.id.unshift(100000);
        left.country_name = "全国";
        if (right.length == 0) {
          right.push(_lodash.cloneDeep(left));
          clearCityArr();
        } else {
          message.error("已有相同区域！");
        }
        return;
      }
      if (right.length == 0) {
        left.id.unshift(100000);
        right.push(_lodash.cloneDeep(left));
        clearCityArr();
        return false;
      } else {
        left.id.unshift(100000);
        for (var i in right) {
          if (left.country_name == "全国" || right[i].country_name == "全国") {
            message.error("已有相同区域！");
            return false;
          }
          if (
            right[i].province_name == left.province_name &&
            right[i].city_name == left.city_name &&
            right[i].area_name == left.area_name
          ) {
            message.error("已有相同区域！");
            return false;
          }
          if (
            right[i].province_name == left.province_name &&
            right[i].city_name == left.city_name
          ) {
            if (right[i].id.length !== left.id.length) {
              message.error("已有相同区域！");
              return false;
            }
          }
          if (right[i].province_name == left.province_name) {
            if (right[i].city_name == "" || left.city_name == "") {
              message.error("已有相同区域！");
              return false;
            }
          }
        }
      }
      right.push(_lodash.cloneDeep(left));
      clearCityArr();
    };
    // 删除销售区域
    const delRegion = (e) => {
      state.rigthArr.splice(e, 1);
    };

    // 经纬度选择完毕
    const confirm = (value) => {
      // form.value.province = value.province;
      // form.value.city = value.city;
      // form.value.region = value.district;
      // form.value.address = value.street;
      form.value.lat = value.lat;
      form.value.lng = value.lng;
      state.showMap = false;
    };
       //选择省市区
    const onChangeAddress = (e, s) => {
      form.value.province = s[0].name;
      form.value.city = s[1].name;
      form.value.region = s[2].name;
      state.mapProvince = {
        province_name: s[0].name,
        city_name: s[1].name,
        area_name: s[2].name,
      };
    };
    return {
      ...toRefs(state),
      form,
      onChangeAddress,
      onSubmit,
      selectArea,
      selectCity,
      selectProvince,
      addCity,
      delRegion,
      confirm,
      ruleForm,
      SaleCatList
    };
  },
};
</script>
<style>
.xing::before {
  display: inline-block;
  margin-right: 4px;
  color: #ff4d4f;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}
</style>
